import React, { useState } from "react";

export default function Logo({ className = "h-16" }) {
	const [imgFailed, setImgFailed] = useState(false);
	
	return (
		<div className={`flex items-center gap-2 ${className}`}>
		{!imgFailed ? (
			<img
			src="/logo.png"
			alt="Cedar Fork Farm"
			className="h-full w-auto object-contain"
			onError={() => setImgFailed(true)}
			/>
			
		) : (
			/* Text fallback if logo.png can't be found */
			<div>
			<div className="text-farm-cream font-bold text-lg leading-tight">
			Cedar Fork Farm
			</div>
			<div className="text-farm-tan text-xs">
			Fresh from our family
			</div>
			</div>
		)}
		<div>
		<div className="text-farm-green font-bold text-lg leading-tight">
		Cedar Fork Farm
		</div>
		<div className="text-farm-brown text-xs">Fresh from our family</div>
		</div>
		</div>
	);
}
